export function densityForWidth(width) {
  if (width < 1024 || width >= 1920) return 1;
  if (width <= 1728) return Math.max(0.6, width / 2160);
  return 0.8 + (width - 1728) / 960;
}

export function displayScale() {
  return Number(document.documentElement.dataset.displayScale) || 1;
}

export const viewportWidth = () => window.innerWidth / displayScale();
export const viewportHeight = () => window.innerHeight / displayScale();
export const layoutCoordinate = value => value / displayScale();
export const viewportClientWidth = () => document.documentElement.clientWidth / displayScale();
export const viewportScrollY = () => window.scrollY / displayScale();

export function layoutRect(element) {
  const rect = element.getBoundingClientRect();
  const scale = element.closest?.(".mg-density-chart") ? displayScale() : 1;
  if (scale === 1) return rect;
  return {
    x: rect.x / scale, y: rect.y / scale,
    left: rect.left / scale, top: rect.top / scale,
    right: rect.right / scale, bottom: rect.bottom / scale,
    width: rect.width / scale, height: rect.height / scale,
  };
}

export function initializeDisplayDensity() {
  const update = () => {
    const scale = densityForWidth(window.innerWidth);
    const root = document.documentElement;
    root.dataset.displayScale = String(scale);
    root.dataset.shortLayout700 = String(window.innerHeight / scale <= 700);
    root.dataset.shortLayout800 = String(window.innerHeight / scale <= 800);
    root.style.setProperty("--mg-display-scale", String(scale));
    root.style.setProperty("--mg-vw", `${window.innerWidth / scale / 100}px`);
    root.style.setProperty("--mg-vh", `${window.innerHeight / scale / 100}px`);
  };
  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}
